import {
    FilterData,
    FilterBlockTypesEnum,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Dropdown,
            placeholder: "Filter 1",
            name: "filter1",
            filterItems: [
                {
                    name: "filter1_1",
                    label: "label 1.1",
                    value: "filter1_1",
                },
                {
                    name: "filter1_2",
                    label: "label 1.2",
                    value: "filter1_2",
                    disabled: true,
                },
                {
                    name: "filter1_3",
                    label: "label 1.3",
                    value: "filter1_3",
                },
                {
                    name: "filter1_4",
                    label: "label 1.4",
                    value: "filter1_4",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            placeholder: "Filter 2",
            name: "filter2",
            multiple: true,
            options: [
                {
                    value: "value2_1",
                    label: "label 2.1",
                },
                {
                    value: "value2_2",
                    label: "label 2.2",
                },
                {
                    value: "value2_3",
                    label: "label 2.3",
                },
                {
                    value: "value2_4",
                    label: "label 2.4",
                    disabled: true,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Checkbox,
            name: "checkbox1",
            filterItems: [
                {
                    name: "checkbox1_1",
                    value: "yes",
                    label: "checkbox label"
                },
            ],
        },
    ],
};

const responseAllTypes: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Dropdown,
            placeholder: "Filter 1",
            name: "filter1",
            filterItems: [
                {
                    name: "filter1_1",
                    label: "label 1.1",
                    value: "filter1_1",
                },
                {
                    name: "filter1_2",
                    label: "label 1.2",
                    value: "filter1_2",
                    disabled: true,
                },
                {
                    name: "filter1_3",
                    label: "label 1.3",
                    value: "filter1_3",
                },
                {
                    name: "filter1_4",
                    label: "label 1.4",
                    value: "filter1_4",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            placeholder: "Filter 2",
            name: "filter2",
            multiple: true,
            options: [
                {
                    value: "value2_1",
                    label: "label 2.1",
                },
                {
                    value: "value2_2",
                    label: "label 2.2",
                },
                {
                    value: "value2_3",
                    label: "label 2.3",
                },
                {
                    value: "value2_4",
                    label: "label 2.4",
                    disabled: true,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            placeholder: "Filter 3",
            name: "filter3",
            options: [
                {
                    value: "value3_1",
                    label: "label 3.1",
                },
                {
                    value: "value3_2",
                    label: "label 3.2",
                }
            ],
        },
        {
            type: FilterBlockTypesEnum.Checkbox,
            name: "checkbox1",
            filterItems: [
                {
                    name: "checkbox1_1",
                    value: "yes",
                    label: "checkbox label"
                },
            ],
        },
    ],
};


const emptyResponse: FilterData = {
    filterBlocks: [],
};

const writeToFile = (object: FilterData, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "filter-data");
writeToFile(responseAllTypes, "filter-data-all-types");
writeToFile(emptyResponse, "filter-data-empty");
